import axiosClient from "utils/api";
const URI = "/admin/userReportReason";

export const getUserReportReason = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get Report Reason:", error);
    throw error;
  }
};

export const deleteUserReportReason = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Delete Report Reason:", error);
    throw error;
  }
};

export const updateUserReportReason = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update Report Reason:", error);
    throw error;
  }
};

export const addUserReportReason = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Add Report Reason:", error);
    throw error;
  }
};

export const getAllUserReportReason = async () => {
  const URL = `${URI}/all`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get Report Reason:", error);
    throw error;
  }
};
